<!-- 页面废弃，复制到student-programme以v-show缓存，防止跳转后重新渲染 -->

<template>
    <div class="adventure-box">
      <studentBG></studentBG>
      <iframe class="iframe" ref="iframe" style="width: 100%;height:100%;" :src="url" @load="deliverToken"/>
      <!-- 新手引导组件 -->
      <Guide
          :steps="guideSteps"
          storage-key="my_app_guide_completed"
          @complete="onGuideComplete"
      />
    </div>
</template>

<script>
import studentBG from "../student-programme/components/studentBG";
import Guide from '@/components/guide/Guide.vue'
import store from "@/store";
import {language} from "@/biz/static-data";
export default {

  components: { studentBG,Guide },
    data() {
        return {
          url:null,
          // 需要引导的元素
          guideSteps: [
            {
              target: '.iframe',
              text: '這是冒險模式',
              position: 'right'
            }
          ]
        };
    },
    mounted() {
      // this.url=`${process.env.VUE_APP_URL}/web-desktop/`
      this.url="web-desktop/index.html"
      if(store.getters.language == language.en){
        this.url="web-desktop-en/index.html";
      }
      window.addEventListener('message',item=>{
        this.changeRoute(item.data)
        // this.$store.dispatch('setGradeId', item.data.gradeId);
      })
    },
    // watch: {
    //     "$store.getters.currentGradeId": {
    //         handler(v) {
    //           this.gradeId = v
    //           this.$forceUpdate()
    //         },
    //         deep: true,
    //         immediate: true,
    //     },
    // },
    methods:{
      onGuideComplete() {
        console.log('新手引导完成')
      },
      deliverToken(){
        this.$nextTick(() => {
          let obj = this.$refs.iframe.contentWindow
          obj.document.querySelector("h1.header").remove()
          obj.document.querySelector("p.footer").remove()
          obj.document.body.style.cssText="background:none;height:100vh;width:100vw;"
          obj.document.getElementById('GameDiv').style.cssText="border:none;box-shadow:none;width:auto;height:auto;max-width:100vw;max-height:100vh;aspect-ratio:1280/720;margin:auto;position:fixed;top:0;bottom:0;left:0;right:0;"
        })
      },
      changeRoute(data){
        if(data.type&&data.type=="router"){
          switch(data.info){
            case "library":this.$router.push({ path: "/libraryMode" });break;
            case "homework":this.$router.push({ path: "/testMode" });break;
            case "assessment":this.$router.push({ path: `/assessment?gradeId=${this.$store.getters.currentGradeId}` });break;
            default: break;
          }
        }
      }
    }
};
</script>

<style lang="scss" scoped>
.adventure-box{
  display:flex;
  height: calc(100vh - 4.5rem);
  align-items:center;
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .adventure-box{
  height: calc(100vh - 3.5rem);
  }
}
</style>